import { Box, Card, CardContent, Tab, Tabs, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { getPageTitle } from 'src/config/projectConfig';

const activityItems = [
  { id: 'h1', text: 'New case assigned to agent Anya Forger', date: '15 Mar 2026 - 14:30' },
  { id: 'h2', text: "Case status updated to 'In Progress' by agent Loid Forger", date: '14 Mar 2026 - 09:15' },
  { id: 'h3', text: 'New comment added to case by client Damian Desmond', date: '13 Mar 2026 - 16:45' },
  { id: 'h4', text: "Case reassigned to team 'Alpha' by manager Sylvia Sherwood", date: '13 Mar 2026 - 10:00' },
  { id: 'h5', text: 'New case created by client Yor Briar', date: '12 Mar 2026 - 18:20' },
  { id: 'h6', text: 'New case assigned to agent Anya Forger', date: '15 Mar 2026 - 14:30' },
  { id: 'h7', text: "Case status updated to 'In Progress' by agent Loid Forger", date: '14 Mar 2026 - 09:15' },
  { id: 'h8', text: 'New comment added to case by client Damian Desmond', date: '13 Mar 2026 - 16:45' },
  { id: 'h9', text: "Case reassigned to team 'Alpha' by manager Sylvia Sherwood", date: '13 Mar 2026 - 10:00' },
  { id: 'h10', text: 'New case created by client Yor Briar', date: '12 Mar 2026 - 18:20' },
];

const historyTabs = ['Users', 'Accounts', 'My Account'];

const History = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <>
      <Helmet>
        <title>{getPageTitle('History')}</title>
      </Helmet>

      <Box p={3}>
        <Typography variant="h4" fontWeight={600} gutterBottom>
          History
        </Typography>

        <Tabs
          value={activeTab}
          onChange={(_, val) => setActiveTab(val)}
          indicatorColor="primary"
          textColor="primary"
          sx={{ mb: 3, borderBottom: '1px solid #EDF2F7' }}
        >
          {historyTabs.map((t) => (
            <Tab
              key={t}
              label={t}
              sx={{ textTransform: 'none', fontWeight: 500, fontSize: 13 }}
            />
          ))}
        </Tabs>

        <Card>
          <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
            <Box px={2.5} pt={2} pb={1}>
              <Typography variant="h6" fontWeight={600}>
                Recent Activity
              </Typography>
            </Box>

            {activityItems.map((item) => (
              <Box
                key={item.id}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                px={2.5}
                py={1.25}
                borderBottom="1px solid #EDF2F7"
              >
                <Typography variant="body2" fontSize={13} color="textPrimary">
                  {item.text}
                </Typography>
                <Box display="flex" alignItems="center" gap={0.5} whiteSpace="nowrap" ml={2}>
                  <Typography variant="caption" fontSize={12} sx={{ color: '#38B2AC' }}>
                    {item.date}
                  </Typography>
                  <PersonIcon sx={{ fontSize: 14, color: '#A0AEC0' }} />
                  <Typography variant="caption" fontSize={12} color="textSecondary">
                    System
                  </Typography>
                </Box>
              </Box>
            ))}

            <Box display="flex" justifyContent="flex-end" px={2.5} py={1.5}>
              <Typography
                variant="body2"
                color="primary"
                fontSize={13}
                sx={{ cursor: 'pointer', fontWeight: 500 }}
              >
                See all
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default History;
